module.exports = __webpack_public_path__ + "img/439e.4ec21f62.png";